export const GET_FUNCTIONAL_LOCATION_INFO_REQUEST = 'GET_FUNCTIONAL_LOCATION_INFO_REQUEST';
export const GET_FUNCTIONAL_LOCATION_INFO_SUCCESS = 'GET_FUNCTIONAL_LOCATION_INFO_SUCCESS';
export const GET_FUNCTIONAL_LOCATION_INFO_FAILURE = 'GET_FUNCTIONAL_LOCATION_INFO_FAILURE';

export const SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST = 'SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST';
export const SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS = 'SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS';
export const SAVE_FUNCTIONAL_LOCATION_INFO_FAILURE = 'SAVE_FUNCTIONAL_LOCATION_INFO_FAILURE';

export const RESET_SAVE_SUCCESS = 'RESET_SAVE_SUCCESS';
export const RESET_INFO = 'RESET_INFO';
